/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { NodePath } from '../../core/models/NodePath';
import { OasHeader } from '../../openapi/models/OasHeader';
import { IOasHeaderParent } from '../../openapi/models/IOasHeaderParent';
import { MarshallCompat } from '../../compat/MarshallCompat';
import { Node } from '../../core/models/Node';

/**
 * A command used to delete a single header .
 * @author vvilerio
 * @extends AbstractCommand
 * @class
 */
export class DeleteHeaderCommand extends AbstractCommand {
    public _headerName : string;

    public _parentPath : NodePath;

    public _oldHeader : any;

    public constructor(header? : any) {
        if(((header != null && header instanceof <any>OasHeader) || header === null)) {
            let __args = arguments;
            super();
            if(this._headerName===undefined) this._headerName = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldHeader===undefined) this._oldHeader = null;
            if(this._headerName===undefined) this._headerName = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldHeader===undefined) this._oldHeader = null;
            (() => {
                this._headerName = header.getName();
                this._parentPath = Library.createNodePath(header.parent());
            })();
        } else if(header === undefined) {
            let __args = arguments;
            super();
            if(this._headerName===undefined) this._headerName = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldHeader===undefined) this._oldHeader = null;
            if(this._headerName===undefined) this._headerName = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldHeader===undefined) this._oldHeader = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[DeleteHeaderCommand] Executing.");
        this._oldHeader = null;
        let parent : IOasHeaderParent = <IOasHeaderParent><any>this._parentPath.resolve(document);
        let header : OasHeader = parent.getHeader(this._headerName);
        if(this.isNullOrUndefined(header)) {
            return;
        }
        parent.removeHeader(this._headerName);
        this._oldHeader = Library.writeNode(header);
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[DeleteHeaderCommand] Reverting.");
        if(this.isNullOrUndefined(this._oldHeader)) {
            return;
        }
        let parent : IOasHeaderParent = <IOasHeaderParent><any>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(parent)) {
            return;
        }
        let header : OasHeader = parent.createHeader(this._headerName);
        Library.readNode(this._oldHeader, header);
        parent.addHeader(this._headerName, header);
    }
}
DeleteHeaderCommand["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteHeaderCommand";
DeleteHeaderCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




